import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import { toast } from "react-toastify";
import apiClient from "./apiClient";

// Legacy Firebase implementation kept during the backend migration:
// import { getDatabase, ref, update } from "firebase/database";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "#fff",
  padding: "24px",
  borderRadius: "8px",
  width: "400px",
  boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
};

export default function UpdateMembershipModal({
  open,
  onClose,
  userId,
  currentType,
  currentSubscription,
  onMembershipUpdated,
}) {
  const [selectedType, setSelectedType] = useState(currentType || "Basic");

  useEffect(() => {
    setSelectedType(currentType || "Basic");
  }, [currentType]);

  const handleUpdate = async () => {
    try {
      // Legacy Firebase update kept for reference:
      // await update(ref(db, `users/${userId}/activesubscription`), {
      //   type: selectedType,
      // });
      await apiClient.put(`/users/${userId}`, {
        activesubscription: {
          ...(currentSubscription || {}),
          type: selectedType,
        },
      });
      toast.success(`Membership updated to ${selectedType}`);
      if (onMembershipUpdated) onMembershipUpdated(true);
      onClose();
    } catch (error) {
      //  console.error("Error updating membership:", error);
      toast.error("Failed to update membership.");
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <Typography variant="h6" mb={2}>
          Update Membership
        </Typography>

        <FormControl fullWidth sx={{ mb: 3 }}>
          <InputLabel id="membership-type-label">Membership Type</InputLabel>
          <Select
            labelId="membership-type-label"
            value={selectedType}
            label="Membership Type"
            onChange={(e) => setSelectedType(e.target.value)}
            sx={{
              height: 48,
              borderRadius: 1,
              "& .MuiSelect-select": {
                paddingY: 1.2,
                paddingX: 2,
              },
            }}
          >
            <MenuItem value="Basic">Basic</MenuItem>
            <MenuItem value="Standard">Standard</MenuItem>
            <MenuItem value="Premium">Premium</MenuItem>
          </Select>
        </FormControl>

        <Typography variant="body2" mb={3}>
          Current Subscription Type : <strong>{currentType || "None"}</strong>
        </Typography>
        <div className="d-flex justify-content-end gap-2 mt-4">
          <button
            className="btn btn-outline-secondary pt-2 pb-2"
            style={{ width: 120 }}
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            className="btn btn-success pt-2 pb-2"
            style={{ width: 120 }}
            onClick={handleUpdate}
          >
            Update
          </button>
        </div>
      </Box>
    </Modal>
  );
}
